export const assignTemplatesValidationErrorColumns = [
  {
    title: 'Row Number',
    dataIndex: 'rowNumber',
    key: 'rowNumber',
    align: 'center',
    width: 100,
  },
  {
    title: 'Columns with Invalid Values',
    dataIndex: 'errorMessage',
    key: 'errorMessage',
    align: 'center',
    width: 400,
  },
];
